// extracted by mini-css-extract-plugin
export var divider = "_rk-0";
export var systemMessage = "_rk-1";
export var systemMessageWrapper = "_rk-2";